import { FaiBase } from '../../../../baseBtl/catalog/products/subscription/plan/fai';

export class Fai extends FaiBase {}
